import React from "react"
import { Button as BootstrapButton } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { LoadingSpinner } from "shared/ui/loading-spinner/LoadingSpinner"
import { OverlayHeader } from "shared/ui/overlay/OverlayHeader"
import { OverlayWrapper } from "shared/ui/overlay/OverlayWrapper"

export interface DemandRequestOverlayViewModel {
  form: React.ReactNode
  isLoading?: boolean
  closeOverlay?: () => void
}

export const DemandRequestOverlayView = React.memo(
  ({ form, isLoading, closeOverlay }: DemandRequestOverlayViewModel) => {
    const { t } = useTranslation()
    return (
      <OverlayWrapper
        id="demand-request-overlay"
        className="demand-request-overlay mobile-fullscreen"
        classNamePrefix="demand-request-overlay"
      >
        <OverlayHeader.Container>
          <OverlayHeader.Title>
            {t("DemandRequest.DemandRequest")}
          </OverlayHeader.Title>
          <OverlayHeader.CloseButton
            className="primary"
            onClick={closeOverlay}
          />
        </OverlayHeader.Container>
        <div
          className={classNames("demand-request-overlay__content", {
            loading: isLoading,
            loaded: !isLoading
          })}
        >
          <Icon
            name={IconName.CHECK_CIRCLE}
            size={IconSize.XXXL}
            className="filter-success flex-shrink-0 demand-request-overlay__success-icon"
          />
          <Icon
            name={IconName.CLOSE_CIRCLE}
            size={IconSize.XXXL}
            className="color-danger flex-shrink-0 demand-request-overlay__failure-icon"
          />
          {isLoading ? <LoadingSpinner /> : form}
          <BootstrapButton
            variant="primary"
            onClick={closeOverlay}
            className="demand-request-overlay__close-button"
          >
            {t("General.Close")}
          </BootstrapButton>
        </div>
      </OverlayWrapper>
    )
  }
)
